<template>
  <div class="insurancePlanPc">
    <div class="backgroundWhite">
      <div class="container insuranceItem">
        <div class="title">商业保险创新解决方案</div>
        <div class="subTitle">针对产险、寿险、养老险、健康险等不同保险公司，以及保险经纪公司、代理人等业务痛点，提供全链路解决方案，<br />通过增值服务、保险产品创新、智能营销等多种形式，实现保费规模增长可持续。</div>
        <img src="https://cdn.youjiajk.com/insurancePlan1.png" width="1200" height="271" alt="">
      </div>
    </div>
    <div class="backgroundGray">
      <div class="container insuranceItem">
        <div class="title">健康企业一站式解决方案</div>
        <div class="subTitle">聚焦员工专属福利平台建设，提供“医健检险”综合解决方案，通过企业云诊所和医护到企业，解决线上+线下场景<br/>的医疗服务需求、优选健康商城、提供健康数据看板等模块，实现员工健康风险可预防，送健康到企业。</div>
        <img src="https://cdn.youjiajk.com/insurancePlan2.png" width="1200" height="476" alt="">
      </div>
    </div>
    <div class="backgroundWhite">
      <div class="container insuranceItem">
        <div class="title">医疗行业解决方案</div>
        <div class="subTitle">药械与健管服务深度结合，探索慢病管理新模式，丰富售后权益、促进品类增长，开发会员运营新思路，实现药械<br/>用户健康状态可追踪，可管理。</div>
        <img src="https://cdn.youjiajk.com/insurancePlan3.png" width="1200" height="332" alt="">
      </div>
    </div>
    <div class="backgroundGray">
      <div class="container insuranceItem">
        <div class="title">智慧康养解决方案</div>
        <div class="subTitle">面向银发人群，满足医养需求，通过助医和助诊的家医优护体系、通过慢病管理，主动关怀、主动管理、线上+线下<br />指导、专病专护等方式，实现适老化健管服务可实施，给与老人一个高品质的老年生活。</div>
        <img src="https://cdn.youjiajk.com/insurancePlan4.png" width="1200" height="476" alt="">
      </div>
    </div>
    <div class="backgroundWhite">
      <div class="container insuranceItem">
        <div class="title">会员运营综合解决方案</div>
        <div class="subTitle">围绕各行业属性及用户特点，提供符合客户需求的医疗健康综合解决方案，以高定制、高体验、高品质的“医-健-险”产品，<br/>实现会员权益价值最大化。</div>
        <img src="https://cdn.youjiajk.com/insurancePlan5.png" width="1200" height="332" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style scoped lang="less">
  .backgroundGray {
    background: #F8F9FD;
  }
  .backgroundWhite {
    background: #FFFFFF;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .insurancePlanPc {
    .insuranceItem{
      padding: 140px 0;
      text-align: center;
      font-family: Source Han Sans CN, Source Han Sans CN-5;
      .title {
        font-size: 40px;
        font-weight: 400;
        color: #333333;
        line-height: 60px;
        margin-bottom: 20px;
      }
      .subTitle{
        font-size: 20px;
        font-weight: 400;
        color: #363636;
        line-height: 30px;
        margin-bottom:29px;
      }
    }
  }


</style>


// WEBPACK FOOTER //
// src/views/pc/insurancePlanPc.vue